<template>
    <div class="staGrid">
        <div class="staBox">
            <user-stats></user-stats>
        </div>
        <div class="staBox">
            <views-stats></views-stats>
        </div>
    </div>
</template>
<script>
    import userStats from './widgets/statistics/userStats.vue'
    import viewsStats from './widgets/statistics/viewsStats.vue'
    export default {
        name: 'DashboardAdminVx',
        components: {
            userStats,
            viewsStats
        },
        data() { }
    }
</script>
<style scoped>
    .staGrid {
        color: white;
        display: grid;
        grid-template-columns: 50% 50%;
        gap: 20px;
        margin-top: 30px;
        margin-right: 40px;
    }

    div.staBox {
        color: white;
    }
</style>